import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Activar la animación después de que el componente se monte
    setIsVisible(true);
  }, []);

  return (
    <header className="header">
      <div className="watercolor-bg">
        <div className="header-content">
          <h1 
            className={`celebration-type ${isVisible ? 'fade-in-down' : ''}`}
            style={{ animationDelay: '0.3s' }}
          >
            MIS XV AÑOS
          </h1>
          <h2 
            className={`name ${isVisible ? 'fade-in-down' : ''}`}
            style={{ animationDelay: '0.6s' }}
          >
            Carol
          </h2>
          <p 
            className={`date ${isVisible ? 'fade-in-down' : ''}`}
            style={{ animationDelay: '0.9s' }}
          >
            09 DE MAYO 2026
          </p>
          <div 
            className={`scroll-indicator ${isVisible ? 'fade-in-up' : ''}`}
            style={{ animationDelay: '1.5s' }}
          >
            <div className="heart">♡</div>
            <p>DESLIZA</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;